'use strict';
const validations = {
  required: (v: string) => {
    return v ? true : "Este campo é obrigatório!";
  },
  hour: (v: string) => {
    const msgMins = "O valor máximo para os minutos é 59";
    const msgHours = "O valor máximo para as horas é 23";
    const msgInvalidFormat = "Formato Inválido";
    if (v) {
      const values = v.split(":");
      if (values.length == 2) {
        const hours = parseInt(values[0]);
        const minutes = parseInt(values[1]);
        if (hours < 24) {
          if (minutes < 60) {
            return true;
          } else {
            return msgMins;
          }
        } else {
          return msgHours;
        }
      } else {
        return msgInvalidFormat;
      }
    }
    return true;
  }
}

export default validations;